import axios from "axios";
import store from "@store";

const instance = axios.create({
	baseURL: process.env.VUE_APP_BDX_VALIDATION_API_URL,
});

instance.interceptors.request.use((config) => {
	const accessToken = store.getters.accessToken;

	if (accessToken) {
		config.headers["Authorization"] = `Bearer ${accessToken}`;
	}

	return config;
});

export default instance;
